import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ContestService} from '../../service/contest.service';
import {TenantService} from '../../service/tenant.service';
import {Role} from '../../model/auth/Role';
import {NotificationHandler} from '../../helper/notification.handler';
import {EventType, TrackingService} from '../../service/tracking.service';
import {PaymentStatus} from '../../model/Payment';

@Component({
  selector: 'contest-payment-confirm',
  templateUrl: './contest-payment-confirm.component.html',
  styleUrls: ['./contest-payment-confirm.component.scss']
})
export class ContestPaymentConfirmComponent implements OnInit {

  @Input() contestId?: string;
  @Input() userId?: string;
  @Input() role?: Role;
  @Input() groupId?: string;

  @Input() iFrameMode = true;

  @Output() statusChanged = new EventEmitter<boolean>();

  status?: string;

  constructor(private contestService: ContestService,
              private tenantService: TenantService,
              private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.checkPaymentStatus();
  }

  private checkPaymentStatus() {
    const tenant = this.tenantService.getTenant();
    if (tenant && this.contestId) {
      if (this.userId && this.role) {
        this.contestService.checkPaymentStatus(tenant.id, this.contestId, this.role, this.userId).subscribe(user => {
          if (user && user.paymentStatus) {
            this.reportPurchase(user.paymentPrice || 0, user.paymentStatus, user.paymentName);
          }

          if (this.iFrameMode) {
            ContestPaymentConfirmComponent.closeModal();
          } else {
            this.prepareStatus(user.paymentStatus);
          }
        }, error => {
          NotificationHandler.handleError($localize`:Notifications|Contest payment confirmation has failed message@@notifications-contest-payment-confirmation-failed-error:Contest payment confirmation has failed`, error);
          ContestPaymentConfirmComponent.closeModal();
        });
      } else {
        this.contestService.checkPaymentGroupStatus(tenant.id, this.contestId, this.groupId || '').subscribe(group => {
          if (group && group.paymentStatus) {
            this.reportPurchase(group.paymentPrice || 0, group.paymentStatus, group.paymentName);
          }

          if (this.iFrameMode) {
            ContestPaymentConfirmComponent.closeModal();
          } else {
            this.prepareStatus(group.paymentStatus);
          }
        }, error => {
          NotificationHandler.handleError($localize`:Notifications|Contest payment confirmation has failed message@@notifications-contest-payment-confirmation-failed-error:Contest payment confirmation has failed`, error);
          ContestPaymentConfirmComponent.closeModal();
        });
      }
    }
  }

  private reportPurchase(price: number, status: PaymentStatus, paymentName?: string) {
    switch (status) {
      case PaymentStatus.pending:
        break;
      case PaymentStatus.successful:
        this.trackingService.sendEvent(EventType.purchase, undefined, paymentName, price / 100);
        break;
      case PaymentStatus.failed:
        this.trackingService.sendEvent(EventType.purchase_failed, undefined, paymentName, price / 100);
        break;
      case PaymentStatus.canceled:
      case PaymentStatus.scheduled:
        this.trackingService.sendEvent(EventType.remove_from_cart, undefined, paymentName);
        break;
    }
  }

  private prepareStatus(status?: PaymentStatus) {
    if (status) {
      switch (status) {
        case PaymentStatus.pending:
          this.status = $localize`:Notifications|Contest payment pending message@@notifications-contest-payment-pending-message:Contest payment verification is in progress`;
          break;
        case PaymentStatus.successful:
          this.status = this.groupId
            ? $localize`:Notifications|Contest group payment successful message@@notifications-contest-group-payment-successful-message:Contest payment for a group of participants completed successfully`
            : $localize`:Notifications|Contest payment successful message@@notifications-contest-payment-successful-message:Contest payment completed successfully`;
          this.statusChanged.emit(true);
          break;
        case PaymentStatus.failed:
          this.status = this.groupId
            ? $localize`:Notifications|Contest group payment failed message@@notifications-contest-group-payment-failed-message:Contest payment for a group of participants has failed`
            : $localize`:Notifications|Contest payment failed message@@notifications-contest-payment-failed-message:Contest payment has failed`;
          this.statusChanged.emit(true);
          break;
        case PaymentStatus.canceled:
        case PaymentStatus.scheduled:
          this.status = this.groupId
            ? $localize`:Notifications|Contest group payment canceled message@@notifications-contest-group-payment-canceled-message:Contest payment for a group of participants was canceled`
            : $localize`:Notifications|Contest payment canceled message@@notifications-contest-payment-canceled-message:Contest payment was canceled`;
          this.statusChanged.emit(true);
          break;
      }
    }
  }

  private static closeModal() {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    parent.confirmPaymentCompleted();
  }

}
